import Card from 'react-bootstrap/Card';
import { useNavigate } from 'react-router-dom';

export interface TripProps {
  id: string;
  title: string;
  description: string;
  createdBy: string;
  createdAt: string;
  imgUrl: {
    src: string;
    alt: string;
  };
}

function TripCard(trip: TripProps) {
  const navigate = useNavigate();
  const handleClick = () => navigate(`/app/trips/${trip.id}`);

  return (
    <Card
      onClick={handleClick}
      className='trip-card'
      id={trip.id.toString()}
    >
      {/* <CardHeader>
        <Card.Title>
          <h2>{trip.title}</h2>
        </Card.Title>
      </CardHeader> */}
      <Card.Img
        variant='top'
        {...trip.imgUrl}
      />
      <Card.Body>
        <div>
          <Card.Title>
            <h2>{trip.title}</h2>
          </Card.Title>
        </div>
      </Card.Body>
    </Card>
  );
}

export default TripCard;
